import React from 'react';

import { Button } from '@/app/components/button';
import { IconHome } from '@/app/components/icons/ui-actions/icon-home';
import { Container } from '@/app/components/layouts/container';
import { Section } from '@/app/components/layouts/section';
import { Image } from '@/app/components/media/image';
import { generateSources } from '@/app/components/media/image/generate-sources';
import type { ImageProps } from '@/app/components/media/image/types';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

const CTA = {
  label: 'กลับไปยังหน้าหลัก',
  href: '/',
  icon: <IconHome />,
};

export interface ErrorStatusProps {
  title: string;
  description: string;
  imageMobile?: Omit<ImageProps, 'aspectRatio' | 'alt'>;
  imageDesktop?: Omit<ImageProps, 'aspectRatio' | 'alt'>;
}
export const ErrorStatus = ({
  title,
  description,
  imageMobile,
  imageDesktop,
}: ErrorStatusProps) => {
  return (
    <Section
      size="none"
      {...createDataAttributes({ test: `section-error-${title}` })}
      className="relative w-full"
    >
      {!!imageMobile && !!imageDesktop && (
        <Image
          priority
          src={imageMobile.src}
          alt={title}
          width={imageMobile.width}
          height={imageMobile.height}
          aspectRatio={['aspect-1-1', 'lg:aspect-8-3']}
          sources={generateSources('overallLgDesktop', {
            mobileSrc: imageMobile.src,
            mobileOptions: {
              crop: '1:1',
            },
            desktopSrc: imageDesktop.src,
            desktopOptions: {
              crop: '8:3',
            },
          })}
        />
      )}
      <Container className="absolute inset-0 flex flex-col items-center justify-center text-center">
        <div className="font-noto-bold relative mb-8 text-white">
          {!!title && <h1 className="font-display text-display">{title}</h1>}
          {!!description && (
            <p
              className="text-sub-h2 where-span:text-inline-wrap"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
        <Button href={CTA.href} iconBefore={CTA.icon}>
          {CTA.label}
        </Button>
      </Container>
    </Section>
  );
};
